export default {
  settings: {
    title: '설정',
    account_related: '계정 관련',
    // user_related: "",
    add_user_title: '이용자 추가',
    edit_user_title: '이용자 편집',
    label: {
      enabled: '있음',
      not_set: '미설정',
    },
    company: {
      title: '기업 정보',
      name: '회사명',
      english_name: 'English name',
      scale: '사원 수',
      industry_type: '업종',
      plan: '요금제',
      location: '주소',
      allowed_ip: 'IP 주소 제한',
      mfa: 'SMS 인증',
      sales_amount: '매출액',
      country: '나라',
    },
    contract_plans: {
      buyer: '바이어 요금제',
      supplier: '공급자 요금제',
    },
    user: {
      title: '이용자 목록',
      name: '성명',
      first_name: '이름',
      last_name: '성',
      email: '이메일 주소',
      email_unverified: '소통 전',
      password: '패스워드',
      password_protection: '보안을 위하여 표시하지 않습니다',
      phone_number: '전화번호',
      role: {
        title: '권한',
        admin: '관리자',
        general: '일반',
      },
      locale: '언어 선택',
      action: '조작',
      total: '총 {total}건(최대 {max}건)',
    },
    button: {
      create: '이용자 추가',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: '【주의 사항】',
    cautions_01: '이메일 주소는 변경할 수 없습니다. 이메일을 재설정하려면 새롭게 이용자를 생성해 주세요.',
    cautions_02: '전화번호는 SMS 인증이 설정되어 있는 경우, 필수입니다.',
    cautions_03: '패스워드 초기화는 등록 이메일 주소에 송신된 확인 코드를 패스워드 재설정 화면에 입력하여 실시해 주세요',
    cautions_04: '이용자 삭제를 해도, 응답한 데이터나 스코어카드는 삭제되지 않습니다.',
    messages: {
      user_update: '이용자 정보 갱신하기',
      user_delete: '이용자 삭제하기',
      confirm_delete: '이 이용자를 삭제하시겠습니까?',
      // complete_create: "",
      complete_update: '이용자 정보의 갱신이 완료되었습니다.',
      complete_delete: '이용자 정보의 삭제가 완료되었습니다.',
      disabled_delete: '관리자가 사라지기 때문에 삭제할 수 없습니다',
      disabled_delete_by_auth: '관리자만 삭제할 수 있습니다',
      invalid_form: '입력 내용에 누락된 것이 있습니다.',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: '’추가’를 클릭하면, 입력한 이메일 주소에 확인 메일이 송신됩니다. \n그 후, 로그인 ID와 패스워드가 기재된 메일이 송신됩니다.',
      caution_two: '전화번호는 SMS 인증이 설정되어 있는 경우, 필수입니다.',
      caution_three: '이용자는 최대 5명까지 추가 가능합니다.',
      user_add_title: '이용자 추가하기',
      user_add_message_one: '입력하신 이메일 주소로 메일을 보냈습니다.',
      user_add_message_two: '메일을 확인하신 후 메일 내용에 따라 로그인해 주세요.',
    },
    tips: {
      role: '‘관리자’ 권한은 이용자의 추가나 삭제를 할 수 있지만, ‘일반’ 권한으로는 할 수 없습니다.',
      locale: '로그인 후에 초기 설정에서 표시되는 언어를 선택할 수 있습니다.',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: '로그아웃하여 패스워드 재설정 화면으로 넘어가도 되겠습니까? 패스워드 재설정 화면에서는 등록된 이메일 주소로 보낸 메일에 기재된 확인 코드를 입력해 주세요.',
      reset: '초기화하기',
    },
  },
}
